/** Canonical event read contract owned by monitoring-backend (PR #237).
 * Identity/progression is server-owned. Never group these entries by title or URL.
 */
export type MonitoringEvent = {
  event_id: string; company_id: string; revision: number;
  legacy_signal_ids: string[]; feedback_signal_id: string;
  feedback: 'useful' | 'not_relevant' | null;
  title: string; summary: string | null; change_summary: string | null;
  why_relevant: string | null; relevance?: string | null; limitations: string | null;
  placement: 'event' | 'background'; evidence_status: 'confirmed' | 'unconfirmed';
  stage: string | null; status: 'occurred' | 'planned'; event_date: string | null; timing_status: string;
  first_discovered_at: string | null; last_material_change_at: string | null; last_observed_at: string | null;
  sources: { url: string; title: string | null; excerpt: string; claim?: string | null;
    published_at?: string | null; evidence_status: 'confirmed' | 'unconfirmed'; check_reason?: string | null; observed_at?: string | null }[];
  timeline: { revision: number; signal_id: string; stage: string | null; status: string;
    summary: string | null; change_summary: string | null; event_date: string | null;
    discovered_at: string | null; evidence_status: string; confirmed_at: string | null; source_url: string | null }[];
};
export type MonitoringEventsQuery = { company_id?: string; since: string; until: string; limit: number; offset: number };
export type MonitoringEventsPage = {
  schema_version: 1; period: { since: string; until: string };
  events: MonitoringEvent[]; background: MonitoringEvent[];
  summary: { new_count: number; progressed_count: number; pending_count: number;
    verification_upgraded_count: number; event_count: number; background_count: number };
  pagination: { offset: number; limit: number; total: number; background_total: number;
    next_offset: number | null; background_next_offset: number | null };
};
export type LoadMonitoringEvents = (query: MonitoringEventsQuery) => Promise<MonitoringEventsPage>;
export const safeMonitorUrl = (value?: string | null) => {
  try { const url = new URL(value || ''); return /^https?:$/.test(url.protocol) ? url.href : undefined; }
  catch { return undefined; }
};
export function recentMonitoringEvent(event: MonitoringEvent, since: string, until: string) {
  const within = (time: string | null) => !!time && Date.parse(time) >= Date.parse(since) && Date.parse(time) < Date.parse(until);
  // Pending is an as-of backlog. Verification upgrades need not change the event date.
  return event.evidence_status === 'unconfirmed' || within(event.last_material_change_at)
    || event.timeline.some(item => within(item.confirmed_at));
}
